export default "__VITE_ASSET__04790a22__"